import { render, staticRenderFns } from "./Dashboard.vue?vue&type=template&id=3ddbe9b7&"
import script from "../dashboard.js?vue&type=script&lang=js&"
export * from "../dashboard.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports